module.exports = __webpack_public_path__ + "02_mid_yellow.1c18a39a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_mid_yellow.png
// module id = JurC
// module chunks = 0